import React from 'react';
import { CardBody } from '../shared/components/Card';
import { useCallState } from '../shared/contexts/CallProvider';
import { useUIState } from '../shared/contexts/UIStateProvider';
import { Modal } from '../../../../common/components/Modal/Modal';
import { theme } from '../../../../common/styles/theme';
import { trackInviteCopied } from '../../../../common/analytics-addon';

export const LINK_MODAL = 'link';

export const LinkModal = () => {
	const { currentModals, closeModal } = useUIState();
	const { callObject } = useCallState();

	let [url, setUrl] = React.useState('');
	let [isCopy, setCopy] = React.useState(false);

	const onClickCopy = (val = url) => {
		if (!navigator.clipboard?.writeText || !document.hasFocus()) return;
		// Auto-copy-on-open has no real click behind it, so the browser may reject this for lack of
		// user activation (e.g. the very first, auto-shown link modal) — catch it so that's just a
		// silent no-op instead of an unhandled rejection, and only claim success once it actually is one.
		navigator.clipboard.writeText(val)
			.then(() => setCopy(true))
			.then(() => trackInviteCopied())
			.catch(() => {});
	}

	const isOpen = currentModals[LINK_MODAL];

	React.useEffect(() => {
		if (!isOpen) return;
		// Reset the "Copied!" feedback from a previous open — nothing has been copied yet this time.
		setCopy(false);

		const room = callObject && callObject.properties && callObject.properties.url || '';
		const roomName = room.split('/').pop();
		if (roomName) {
			url = location.origin + '/call/' + roomName;

			// if (!isTeacher) url += '/1';

			setUrl(url);
			onClickCopy(url);
		}
	}, [isOpen]);

	return (
		<Modal
			title={'Meeting link'}
			open={!!isOpen}
			onClose={() => closeModal(LINK_MODAL)}
			// Lets UIStateProvider.autoOpenModal find the popup to fly it into its tray button.
			PaperProps={{ className: `modal--${LINK_MODAL}` }}
		>
			<CardBody>

				{!!url && <>
					<p
						style={{
							cursor: 'pointer',
						}}
						onClick={() => onClickCopy()}
					>
						{url}

					</p>

					{isCopy &&
						<p
							style={{
								color: theme.palette.success.main,
							}}
						>
							Copied to clipboard!
						</p>
					}
				</>}

			</CardBody>
		</Modal>
	);
};
